import GrowMutations from './mutation';
import GrowQueries from './query';

export default { query: GrowQueries, mutation: GrowMutations };
